import { Component, OnInit } from '@angular/core';
import { Code } from './../../code/messages';
import {SelectItem} from "../../component/ing/common/selectitem";
import {Message} from "../../component/ing/common/message";
import {MessageService} from "../../component/ing/common/messageservice";

@Component({
  templateUrl: './messages.component.html',
  providers: [MessageService]
})
export class MessagesComponent implements OnInit {

  	code = Code;
  	items: any[];
	headers: any[];
	parameters: any[];
	styleHeader: any[];
	styleValue: any[];
    msgs: Message[] = [];
	
    constructor(private messageService: MessageService) {
    }

    ngOnInit() {
    	
    	this.headers = [
	        {name : "名字"},
	        {name : "类型"},
	        {name : "默认"},
	        {name : "描述"}
	    ];
	    this.parameters = [
	        {name: "value",type: "array",default: "null",des: "要显示的消息数组。"},
	        {name: "style",type: "string",default: "null",des: "组件的内联样式。"},
	        {name: "styleClass",type: "string",default: "null",des: "组件的样式类。"},
	        {name: "closable",type: "boolean",default: "false",des: "定义消息框是否可以被单击图标关闭。"},
            {name: "enableService",type: "boolean",default: "true",des: "是否显示服务消息。"},
            {name: "key",type: "string",default: "null",des: "ID以匹配消息的键以启用基于服务的消息传递中的作用域。"}
	    ];

	    this.styleHeader = [
	    	{name : "名字"},
	        {name : "元素"}
	    ];

	    this.styleValue = [
	    	{name : "ui-messages",el : "容器元素。"},
	    	{name : "ui-messages-info",el : "当容器元素的显示信息的消息。"},
	    	{name : "ui-messages-warn",el : "显示警告消息时的容器元素。"},
	    	{name : "ui-messages-error",el : "显示错误消息时的容器元素。"},
	    	{name : "ui-messages-success",el : "显示成功消息时的容器元素。"},
	    	{name : "ui-messages-close",el : "关闭图标。"},
	    	{name : "ui-messages-icon",el : "严重性图标。"},
            {name : "ui-messages-summary",el : "总结信息。"},
            {name : "ui-messages-detail",el : "详细消息。"}
	    ];
    }

    showSuccess() {
        console.log(1213123);
        this.msgs = [];
        this.msgs.push({severity:'success', summary:'Success Message', detail:'Order submitted'});
    }

    showInfo() {
        this.msgs = [];
        this.msgs.push({severity:'info', summary:'Info Message', detail:'PrimeNG rocks'});
    }

    showWarn() {
        this.msgs = [];
        this.msgs.push({severity:'warn', summary:'Warn Message', detail:'There are unsaved changes'});
    }

    showError() {
        this.msgs = [];
        this.msgs.push({severity:'error', summary:'Error Message', detail:'Validation failed'});
    }

    showMultiple() {
        this.msgs = [];
        this.msgs.push({severity:'info', summary:'Message 1', detail:'PrimeNG rocks'});
        this.msgs.push({severity:'info', summary:'Message 2', detail:'PrimeUI rocks'});
        this.msgs.push({severity:'info', summary:'Message 3', detail:'PrimeFaces rocks'});
    }
    
    showViaService() {
        this.messageService.add({severity:'success', summary:'Service Message', detail:'Via MessageService'});
    }

    clear() {
        this.msgs = [];
    }

}



// WEBPACK FOOTER //
// ./src/app/view/messages/messages.component.ts